/** @file Viewport chords (context viewport, active while the canvas has focus); tool chords come from TOOLS. */
import type { Binding } from '@pose2d/shortcuts/types';

/** R-E1-17. */
export const bindings: Binding[] = [
  { id: 'viewport.frameSelection', keys: 'KeyF', context: 'viewport' },
  { id: 'viewport.toggleMode', keys: 'KeyM', context: 'viewport' },
  { id: 'viewport.toggleSnap', keys: 'Shift+KeyS', context: 'viewport' },
  { id: 'viewport.key', keys: 'KeyK', context: 'viewport' },
  { id: 'viewport.cancel', keys: 'Escape', context: 'viewport' },
];
